// import React, { useState } from 'react';
// import styled from 'styled-components';

// // Styled Components (using the established palette)
// const PageContainer = styled.div`
//     padding: 100px 20px 60px; // Add bottom padding
//     max-width: 1200px;
//     margin: 0 auto;
//     background-color: #FFFFFF; // Background 1
// `;

// const HeroSection = styled.section`
//     text-align: center;
//     margin-bottom: 60px;
//     padding: 40px 20px;
//     background: linear-gradient(135deg, #0A2342, #005f56); // Hero Gradient
//     border-radius: 10px;
//     color: #F4F4F4; // Text (Dark BG)
// `;

// const Title = styled.h1`
//     font-size: 3rem;
//     font-weight: 700;
//     margin-bottom: 15px;
//     text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
// `;

// const Subtitle = styled.p`
//     font-size: 1.3rem;
//     color: rgba(244, 244, 244, 0.9);
//     max-width: 800px;
//     margin: 0 auto;
//     line-height: 1.6;
//     font-weight: 300;
// `;

// const JobListingsSection = styled.section`
//     margin-top: 50px;
// `;

// const SectionTitle = styled.h2`
//     font-size: 2.2rem;
//     color: #0A2342; // Primary Color
//     margin-bottom: 40px;
//     text-align: center;
//     position: relative;
//     font-weight: 700;

//     &::after {
//         content: '';
//         position: absolute;
//         bottom: -10px;
//         left: 50%;
//         transform: translateX(-50%);
//         width: 70px;
//         height: 4px;
//         background: linear-gradient(to right, #0A2342, #00A896); // Section Title Gradient
//         border-radius: 2px;
//     }
// `;

// // Placeholder for Job Listing Card (will likely become a separate component)
// const JobCard = styled.div`
//     background: #F8F9FA; // Background 2
//     padding: 25px 30px;
//     border-radius: 8px;
//     margin-bottom: 25px;
//     box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
//     border-left: 5px solid #00A896; // Teal accent border
//     transition: all 0.3s ease;

//     &:hover {
//         transform: translateY(-5px);
//         box-shadow: 0 8px 15px rgba(0, 0, 0, 0.08);
//     }
// `;

// const JobTitle = styled.h3`
//     color: #0A2342; // Primary Color
//     margin: 0 0 10px 0;
//     font-size: 1.6rem;
//     font-weight: 600;
// `;

// const JobLocation = styled.p`
//     color: #555555;
//     margin: 0 0 15px 0;
//     font-size: 1rem;
//     font-style: italic;
// `;

// const JobDescription = styled.p`
//     color: #333333; // Text (Light BG)
//     line-height: 1.7;
//     margin-bottom: 20px;
// `;

// const ApplyButton = styled.button`
//     background: #00A896; // Secondary/Accent (Teal)
//     color: #FFFFFF;
//     padding: 10px 25px;
//     border: none;
//     border-radius: 50px;
//     font-size: 1rem;
//     font-weight: 500;
//     cursor: pointer;
//     transition: all 0.3s ease;
//     display: inline-flex; // Align icon and text
//     align-items: center;
//     gap: 8px;

//     &:hover {
//         background: #008a79; // Darker Teal
//         box-shadow: 0 4px 12px rgba(0, 168, 150, 0.3);
//         transform: translateY(-2px);
//     }
// `;

// // Placeholder data - replace with fetched data later
// const dummyJobs = [
//     {
//         id: 1,
//         title: 'Senior Frontend Developer',
//         location: 'Remote / Hyderabad, India',
//         description: 'We are looking for an experienced Frontend Developer proficient in React, modern JavaScript, and CSS to build intuitive user interfaces for our innovative platforms...'
//     },
//     {
//         id: 2,
//         title: 'Backend Engineer (Node.js)',
//         location: 'Hyderabad, India',
//         description: 'Join our backend team to design, develop, and maintain scalable server-side applications using Node.js, Express, and databases like MongoDB or PostgreSQL...'
//     },
//     {
//         id: 3,
//         title: 'Cloud Infrastructure Engineer',
//         location: 'Remote',
//         description: 'Seeking a Cloud Engineer experienced with AWS or Azure to manage and optimize our cloud infrastructure, ensuring security, scalability, and cost-effectiveness...'
//     },
// ];

// const Career = () => {
//     // Basic state/handler for application form modal (future implementation)
//     const [showApplicationForm, setShowApplicationForm] = useState(false);
//     const [selectedJobId, setSelectedJobId] = useState(null);

//     const handleApplyClick = (jobId) => {
//         setSelectedJobId(jobId);
//         setShowApplicationForm(true);
//         // In a real app, this would open a modal or navigate to an application form
//         console.log(`Apply button clicked for job ID: ${jobId}`);
//         alert(`Application form for Job ID ${jobId} would open here (modal coming soon).`);
//     };

//     return (
//         <PageContainer>
//             <HeroSection>
//                 <Title>Join Our Team</Title>
//                 <Subtitle>
//                     Explore exciting career opportunities at VVV IT Solutions and be part of a team dedicated to innovation and excellence.
//                 </Subtitle>
//             </HeroSection>

//             <JobListingsSection>
//                 <SectionTitle>Current Openings</SectionTitle>
//                 {dummyJobs.length > 0 ? (
//                     dummyJobs.map((job) => (
//                         <JobCard key={job.id}>
//                             <JobTitle>{job.title}</JobTitle>
//                             <JobLocation>{job.location}</JobLocation>
//                             <JobDescription>{job.description}</JobDescription>
//                             <ApplyButton onClick={() => handleApplyClick(job.id)}>
//                                 Apply Now
//                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                     <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                                 </svg>
//                             </ApplyButton>
//                         </JobCard>
//                     ))
//                 ) : (
//                     <p style={{ textAlign: 'center', color: '#555' }}>No current openings. Please check back later!</p>
//                 )}
//             </JobListingsSection>

//             {/* Placeholder for Application Form Modal */}
//             {/* {showApplicationForm && <ApplicationForm jobId={selectedJobId} onClose={() => setShowApplicationForm(false)} />} */}
//         </PageContainer>
//     );
// };

// export default Career; 








import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FaMapMarkerAlt, FaClock, FaUsers, FaLaptopCode, FaCloud, FaShieldAlt, FaArrowRight, FaBriefcase, FaStar, FaCheckCircle,FaPaperPlane } from 'react-icons/fa';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

// Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 80px;
  padding: 80px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  border-radius: 24px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px var(--theme-shadow-accent);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
    background-blend-mode: overlay;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  
  span {
    display: block;
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #FFC857;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
`;

const BenefitsSection = styled(motion.section)`
  margin: 80px 0;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin: 60px 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: var(--theme-primary);
  margin-bottom: 60px;
  text-align: center;
  position: relative;
  font-weight: 800;
  letter-spacing: -0.02em;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(to right, var(--theme-primary), var(--theme-accent));
    border-radius: 2px;
  }
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

const BenefitCard = styled(motion.div)`
  background: #ffffff;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  border-top: 4px solid var(--theme-accent);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .benefit-icon {
      transform: scale(1.1) rotate(5deg);
      color: var(--theme-accent);
    }
  }
`;

const BenefitIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  margin-bottom: 20px;
  transition: all 0.4s ease;
`;

const BenefitTitle = styled.h3`
  color: var(--theme-primary);
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: 700;
`;

const BenefitDescription = styled.p`
  color: #64748b;
  line-height: 1.6;
  font-size: 1rem;
`;

const JobListingsSection = styled(motion.section)`
  margin: 80px 0;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin: 60px 0;
  }
`;

const JobGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const JobCard = styled(motion.div)`
  background: #ffffff;
  padding: 40px 35px;
  border-radius: 20px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  border-left: 5px solid var(--theme-accent);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .apply-button {
      background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
      transform: translateY(-2px);
    }
  }
`;

const JobHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const JobTitle = styled.h3`
  color: var(--theme-primary);
  font-size: 1.5rem;
  margin: 0 0 10px 0;
  font-weight: 700;
  line-height: 1.3;
  flex: 1;
`;

const JobTypeBadge = styled.span`
  background: var(--theme-accent-soft);
  color: var(--theme-accent);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid var(--theme-accent-soft);
  margin-left: 15px;
  flex-shrink: 0;
`;

const JobMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;

  svg {
    color: var(--theme-accent);
    font-size: 1rem;
  }
`;

const JobDescription = styled.p`
  color: #475569;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 1rem;
  font-weight: 400;
`;

const SkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 25px;
`;

const SkillTag = styled.span`
  background: var(--theme-surface-muted);
  color: var(--theme-primary);
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid var(--theme-border);
`;

const ApplyButton = styled(motion.button)`
  background: linear-gradient(135deg, var(--theme-accent), var(--theme-accent-strong));
  color: #FFFFFF;
  padding: 14px 32px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px var(--theme-shadow-accent);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    &::before {
      left: 100%;
    }

    svg {
      transform: translateX(4px);
    }
  }

  svg {
    transition: transform 0.3s ease;
  }
`;

const NoJobsMessage = styled(motion.div)`
  text-align: center;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  margin: 0 auto;

  svg {
    font-size: 4rem;
    color: #94a3b8;
    margin-bottom: 20px;
  }

  h3 {
    color: var(--theme-primary);
    font-size: 1.5rem;
    margin-bottom: 10px;
    font-weight: 700;
  }

  p {
    color: #64748b;
    font-size: 1.1rem;
    line-height: 1.6;
  }
`;

const ApplicationModal = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled(motion.div)`
  background: #ffffff;
  border-radius: 24px;
  padding: 50px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    padding: 30px 25px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #64748b;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    color: var(--theme-primary);
    background: rgba(0, 0, 0, 0.05);
  }
`;

const SuccessMessage = styled(motion.div)`
  background: linear-gradient(135deg, var(--theme-accent), var(--theme-accent-strong));
  color: white;
  padding: 30px;
  border-radius: 16px;
  text-align: center;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-weight: 600;
  font-size: 1.1rem;
  box-shadow: 0 8px 25px var(--theme-shadow-accent);
`;

// Enhanced dummy data
const dummyJobs = [
  {
    id: 1,
    title: 'Senior Frontend Developer',
    location: 'Remote / Hyderabad, India',
    type: 'Full-time',
    experience: '3-5 years',
    description: 'We are looking for an experienced Frontend Developer proficient in React, modern JavaScript, and CSS to build intuitive user interfaces for our innovative platforms. You will work closely with our design and backend teams to create seamless user experiences.',
    skills: ['React', 'TypeScript', 'CSS3', 'Redux', 'Jest', 'Webpack']
  },
  {
    id: 2,
    title: 'Backend Engineer (Node.js)',
    location: 'Hyderabad, India',
    type: 'Full-time',
    experience: '2-4 years',
    description: 'Join our backend team to design, develop, and maintain scalable server-side applications using Node.js, Express, and databases like MongoDB or PostgreSQL. You will be responsible for building robust APIs and ensuring system reliability.',
    skills: ['Node.js', 'Express', 'MongoDB', 'PostgreSQL', 'Redis', 'Docker']
  },
  {
    id: 3,
    title: 'Cloud Infrastructure Engineer',
    location: 'Remote',
    type: 'Full-time',
    experience: '4-6 years',
    description: 'Seeking a Cloud Engineer experienced with AWS or Azure to manage and optimize our cloud infrastructure, ensuring security, scalability, and cost-effectiveness. You will implement CI/CD pipelines and automate deployment processes.',
    skills: ['AWS', 'Azure', 'Terraform', 'Kubernetes', 'CI/CD', 'DevOps']
  },
  {
    id: 4,
    title: 'UI/UX Designer',
    location: 'Hyderabad, India',
    type: 'Full-time',
    experience: '2-3 years',
    description: 'Create beautiful and intuitive user interfaces for our digital products. Collaborate with product managers and developers to transform complex requirements into elegant design solutions.',
    skills: ['Figma', 'Adobe XD', 'User Research', 'Prototyping', 'Design Systems']
  },
];

const benefits = [
  {
    icon: <FaUsers />,
    title: 'Collaborative Culture',
    description: 'Work with talented professionals in an inclusive and supportive environment that fosters growth and innovation.'
  },
  {
    icon: <FaLaptopCode />,
    title: 'Latest Technologies',
    description: 'Get hands-on experience with cutting-edge technologies and modern development practices.'
  },
  {
    icon: <FaClock />,
    title: 'Flexible Hours',
    description: 'Enjoy flexible working hours and remote work options to maintain your work-life balance.'
  },
  {
    icon: <FaStar />,
    title: 'Career Growth',
    description: 'Clear career progression paths with regular training and professional development opportunities.'
  },
  {
    icon: <FaCloud />,
    title: 'Modern Infrastructure',
    description: 'Work with state-of-the-art tools and infrastructure to deliver high-quality solutions.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Job Security',
    description: 'Be part of a stable, growing company with a strong track record and long-term vision.'
  }
];

const Career = () => {
    const [showApplicationForm, setShowApplicationForm] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setShowApplicationForm(true);
        setIsSubmitted(false);
    };

    const handleCloseModal = () => {
        setShowApplicationForm(false);
        setSelectedJob(null);
        setIsSubmitted(false);
    };

    const handleSubmitApplication = (e) => {
        e.preventDefault();
        // Simulate form submission
        setIsSubmitted(true);
        setTimeout(() => {
            handleCloseModal();
        }, 3000);
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    Build Your Career With Us
                    <span>Shape the future of technology</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    Join VVV IT Solutions and be part of a dynamic team that's transforming businesses 
                    through innovative digital solutions. Grow your skills while building impactful products.
                </Subtitle>
            </HeroSection>

            <BenefitsSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle>Why Join Our Team?</SectionTitle>
                <BenefitsGrid>
                    {benefits.map((benefit, index) => (
                        <BenefitCard
                            key={index}
                            variants={itemVariants}
                            whileHover={{ y: -5 }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <BenefitIcon className="benefit-icon">
                                {benefit.icon}
                            </BenefitIcon>
                            <BenefitTitle>{benefit.title}</BenefitTitle>
                            <BenefitDescription>{benefit.description}</BenefitDescription>
                        </BenefitCard>
                    ))}
                </BenefitsGrid>
            </BenefitsSection>

            <JobListingsSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle>Current Openings</SectionTitle>
                {dummyJobs.length > 0 ? (
                    <JobGrid>
                        {dummyJobs.map((job, index) => (
                            <JobCard
                                key={job.id}
                                variants={itemVariants}
                                whileHover={{ y: -5 }}
                                transition={{ delay: index * 0.1 }}
                            >
                                <JobHeader>
                                    <JobTitle>{job.title}</JobTitle>
                                    <JobTypeBadge>{job.type}</JobTypeBadge>
                                </JobHeader>
                                
                                <JobMeta>
                                    <MetaItem>
                                        <FaMapMarkerAlt />
                                        {job.location}
                                    </MetaItem>
                                    <MetaItem>
                                        <FaBriefcase />
                                        {job.experience}
                                    </MetaItem>
                                </JobMeta>
                                
                                <JobDescription>{job.description}</JobDescription>
                                
                                <SkillsList>
                                    {job.skills.map((skill, skillIndex) => (
                                        <SkillTag key={skillIndex}>{skill}</SkillTag>
                                    ))}
                                </SkillsList>
                                
                                <ApplyButton 
                                    className="apply-button"
                                    onClick={() => handleApplyClick(job)}
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    Apply Now
                                    <FaArrowRight />
                                </ApplyButton>
                            </JobCard>
                        ))}
                    </JobGrid>
                ) : (
                    <NoJobsMessage variants={itemVariants}>
                        <FaBriefcase />
                        <h3>No Current Openings</h3>
                        <p>
                            We don't have any open positions at the moment, but we're always looking for talented people. 
                            Please check back later or send us your resume for future opportunities.
                        </p>
                    </NoJobsMessage>
                )}
            </JobListingsSection>

            <AnimatePresence>
                {showApplicationForm && selectedJob && (
                    <ApplicationModal
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <ModalContent
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                        >
                            <CloseButton onClick={handleCloseModal}>&times;</CloseButton>
                            
                            {!isSubmitted ? (
                                <>
                                    <h2 style={{ color: 'var(--theme-primary)', marginBottom: '10px', fontSize: '2rem', fontWeight: '700' }}>
                                        Apply for {selectedJob.title}
                                    </h2>
                                    <p style={{ color: '#64748b', marginBottom: '30px' }}>
                                        Fill out the form below to submit your application for this position.
                                    </p>
                                    
                                    <form onSubmit={handleSubmitApplication}>
                                        <div style={{ display: 'grid', gap: '20px', marginBottom: '30px' }}>
                                            <input 
                                                type="text" 
                                                placeholder="Full Name" 
                                                style={{
                                                    padding: '15px 20px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                required 
                                            />
                                            <input 
                                                type="email" 
                                                placeholder="Email Address" 
                                                style={{
                                                    padding: '15px 20px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                required 
                                            />
                                            <input 
                                                type="tel" 
                                                placeholder="Phone Number" 
                                                style={{
                                                    padding: '15px 20px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                required 
                                            />
                                            <textarea 
                                                placeholder="Cover Letter" 
                                                rows="4"
                                                style={{
                                                    padding: '15px 20px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease',
                                                    resize: 'vertical'
                                                }}
                                                required 
                                            />
                                            <input 
                                                type="file" 
                                                accept=".pdf,.doc,.docx"
                                                style={{
                                                    padding: '15px 20px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    fontSize: '1rem'
                                                }}
                                                required 
                                            />
                                        </div>
                                        
                                        <ApplyButton 
                                            type="submit"
                                            style={{ width: '100%', justifyContent: 'center' }}
                                            whileHover={{ scale: 1.02 }}
                                            whileTap={{ scale: 0.98 }}
                                        >
                                            Submit Application
                                            <FaPaperPlane />
                                        </ApplyButton>
                                    </form>
                                </>
                            ) : (
                                <SuccessMessage
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                >
                                    <FaCheckCircle />
                                    Application Submitted Successfully!
                                </SuccessMessage>
                            )}
                        </ModalContent>
                    </ApplicationModal>
                )}
            </AnimatePresence>
        </PageContainer>
    );
};

export default Career;
